import React from 'react';
import { inject, observer } from 'mobx-react';

import Section from '../../../Section/Section';
import Form from '../../../Settings/Form/Form';
import ColorInput from '../Palette/ColorInput';
import { StoresEnum } from '../../../../stores';

const ChannelDefaultStartButtonColor = ({ channelStore: { channel, readOnly, updateChannel } }) => {
  const currentColor = (channel.channelDefaults && channel.channelDefaults.buttonColor) || '';

  const renderFields = () => (
    <ColorInput
      readOnly={readOnly}
      useFormField
      name="buttonColor"
      value={currentColor}
      label="Start button HEX color"
    />
  );

  const onSubmit = data => updateChannel({
    channelDefaults: { ...(channel.channelDefaults || {}), buttonColor: data.buttonColor || '' },
  });

  return (
    <Section title="DEFAULT START BUTTON COLOR">
      <Form
        initialValues={{ buttonColor: currentColor }}
        fields={renderFields()}
        onSubmit={onSubmit}
        hideCancelButton
        hideApproveButton={readOnly}
        approveLabel="Apply"
        approveClass="outlined-secondary"
      />
    </Section>
  );
};

export default inject(StoresEnum.CHANNEL)(observer(ChannelDefaultStartButtonColor));
